<script>
  export let currentSection
  export let sectionNo
  import { addLinks } from '../helpers/addLinks.js'
</script>

<div class="dev section-label">section {sectionNo}</div>
{#each currentSection as section}
  <!-- <section> -->
  {#if section.type === 'crosshead'}
    <div class="crosshead">
      <div class="crosshead-content">
        <div class="crosshead-back">&nbsp;</div>
        <div class="crosshead-inner-content">{section.value.text}</div>
      </div>
    </div>
  {:else}
    <p>{@html addLinks(section.value)}</p>
  {/if}
  <!-- </section> -->
{/each}

<style>
  .section-label {
    font-size: 0.8rem;
    color: gray;
    text-transform: uppercase;
  }
  .crosshead {
    position: relative;
    /* background: green; */
    min-height: 30px;
    display: block;
    margin-bottom: 50px;
    margin-top: 50px;
  }
  .crosshead-content {
    position: absolute;
    top: 0px;
    left: 0px;
    background: #1a1a1a;
    border: solid 1px #fff;
  }
  .crosshead-back {
    z-index: -100;

    position: absolute;
    top: 10px;
    left: 10px;

    background: rgba(255, 105, 180, 0.493);
    padding: 12px 10px;
    width: calc(100% - 20px);
    /* width: 200px; */
  }
  .crosshead-inner-content {
    padding: 10px 20px;
    font-weight: 700;
    font-size: 1.2rem;
  }

  @media only screen and (max-width: 800px) {
    .crosshead-inner-content {
      font-size: 1rem;
    }
  }
</style>
